import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import ukTranslation from './locales/uk/translation.json';

// Configure i18n
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      uk: {
        translation: ukTranslation
      }
    },
    fallbackLng: 'en', // Fallback language if translation not found
    supportedLngs: ['en', 'uk'], // Supported languages

    debug: false, // Set to true for debugging

    interpolation: {
      escapeValue: false // React already escapes values
    },

    // Language detector options
    detection: {
      // Order of detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],

      // Keys to look up language from
      lookupLocalStorage: 'i18nextLng',

      // Cache user language
      caches: ['localStorage'],

      // Don't use cookies for caching
      excludeCacheFor: ['cimode']
    },

    react: {
      // Wait for translations to load before rendering
      useSuspense: true
    }
  });

export default i18n;
